import FileHandler from "@tiptap-pro/extension-file-handler";

export const useFileHandlerExtension = () => {
  const { uploadFile } = useFilesClient();

  return FileHandler.configure({
    allowedMimeTypes: ["image/png", "image/jpeg", "image/gif", "image/webp"],
    onDrop: (currentEditor, files, pos) => {
      files.forEach((file) => {
        uploadFile(file).then((urls) => {
          if (!urls || urls.length === 0) return undefined;

          currentEditor
            .chain()
            .insertContentAt(pos, {
              type: "image",
              attrs: {
                src: urls[0],
              },
            })
            .focus()
            .run();
        });
      });
    },
    onPaste: (currentEditor, files, htmlContent) => {
      files.forEach((file) => {
        if (htmlContent) {
          // if there is htmlContent, stop manual insertion & let other extensions handle insertion via inputRule
          // you could extract the pasted file from this url string and upload it to a server for example
          console.log(htmlContent); // eslint-disable-line no-console
          return false;
        }

        uploadFile(file).then((urls) => {
          if (!urls || urls.length === 0) return undefined;

          currentEditor
            .chain()
            .insertContentAt(currentEditor.state.selection.anchor, {
              type: "image",
              attrs: {
                src: urls[0],
              },
            })
            .focus()
            .run();
        });
      });
    },
  });
};
